var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "video",
    {
      ref: "video",
      staticClass: "front-video",
      style: `z-index:${_vm.zIndex}`,
      attrs: { src: _vm.source, type: "video/mp4", muted: "" },
      domProps: { muted: true },
      on: { click: _vm.pause, ended: _vm.ended },
    },
    [_vm._v("\n    Sorry, video is not supported\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }